import { formatHealthIcon } from '../HealthIcon';
import {
  Row, Data, DataCentered, StyledBox, Icon,
} from './styles';
import { DeleteOutlineIcon } from 'icons';
import {
  ActionButton,
} from 'components';
import { HealthHistItem } from './healthHistoryTable';
import { Profile } from '~/helpers/userProfile';

interface HealthHistoryRowProps {
  item: HealthHistItem;
  profile: Profile;
  onDelete: (item: HealthHistItem) => void;
}

export function HealthHistoryRow({ item, profile, onDelete }: Readonly<HealthHistoryRowProps>): JSX.Element {
  return (
    <Row data-testid="health-history-row">
      <DataCentered>
        <StyledBox health={item.H_INDEX} selected={false} style={{ display: 'inline-block' }}>
          <Icon>{formatHealthIcon(item.H_INDEX)}</Icon>
        </StyledBox>
      </DataCentered>

      <Data>{item.desc}</Data>

      <Data>{new Date(item.date).toLocaleString('pt-BR')}</Data>

      <Data>
        {item.possCauses?.length > 0 && (
          <ul>
            {item.possCauses.map((cause) => (
              <li key={cause}>{cause}</li>
            ))}
          </ul>
        )}
      </Data>

      {profile.manageAllClients && <Data>{item.changeType}</Data>}

      {profile.permissions.HEALTH_MANAGEMENT && (
        <Data>
          <ActionButton onClick={() => onDelete(item)} variant="red-inv">
            <DeleteOutlineIcon />
          </ActionButton>
        </Data>
      )}
    </Row>
  );
}
